import React, { Fragment } from 'react'
import compose from 'recompose/compose'
import pure from 'recompose/pure'
import lifecycle from 'recompose/lifecycle'
import withHandlers from 'recompose/withHandlers'
import scream from 'scream'
import bugsnagClient from 'aria-viewer/core/bugsnagClient'

const withLifeCycle = lifecycle({
    componentDidMount() {
        this.props.scream && this.props.scream.on('orientationchangeend', this.props.handleOrientationChanged)
    },

    componentWillUnmount() {
        this.props.scream && this.props.scream.off('orientationchangeend', this.props.handleOrientationChanged)
    },
})

const handlers = withHandlers({
    handleOrientationChanged: ({ scream, onOrientationChangeEnd }) => event => {
        const orientation = scream.getOrientation()
        const isMinimalView = scream.isMinimalView()
        const viewPortWidth = scream.getViewportWidth()
        const viewPortHeight = scream.getViewportHeight()
        const screenWidth = scream.getScreenWidth()
        const screenHeight = scream.getScreenHeight()
        const notchPadding = scream.getNotchPadding()

        onOrientationChangeEnd &&
            onOrientationChangeEnd(event, {
                orientation,
                isMinimalView,
                viewPortWidth,
                viewPortHeight,
                screenWidth,
                screenHeight,
                notchPadding,
            })
    },
})

const withScream = WrappedComponent => props => {
    try {
        const Scream = scream({
            viewport: false,
            width: {
                portrait: screen.width,
                landscape: screen.height,
            },
        })

        return <WrappedComponent scream={Scream} {...props} />
    } catch (error) {
        bugsnagClient.notify(error)
    }

    return <WrappedComponent {...props} />
}

const ChromeLandscape = ({ children }) => <Fragment>{children}</Fragment>

export default compose(
    withScream,
    handlers,
    withLifeCycle,
    pure
)(ChromeLandscape)
